// TODO server device
/**
 * @param {string} version1
 * @param {string} version2
 * @return {number}
 */

export function compareVersion(version1: string, version2: string): 0 | -1 | 1 {
  const v1Arr = version1.split('.')
  const v2Arr = version2.split('.')
  let i = 0
  while (i < v1Arr.length || i < v2Arr.length) {
    const v1 = parseInt(v1Arr[i] || '0')
    const v2 = parseInt(v2Arr[i] || '0')
    if (v1 > v2) {
      return 1
    }
    if (v1 < v2) {
      return -1
    }
    i++
  }
  return 0
}

function getIsIphoneX() {
  return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
}
function getIsWeChat() {
  const userAgent = navigator.userAgent.toLowerCase()

  // @ts-ignore
  if (userAgent.match(/MicroMessenger/i) === 'micromessenger') {
    return true
  } else {
    return false
  }
}

function getIsIphone() {
  if (typeof window !== 'undefined') {
    return navigator.userAgent.match(/(iPhone)/)
  }
  // TODO server device
  return false
}

function getIsAndroid() {
  if (typeof window !== 'undefined') {
    return navigator.userAgent.match(/(Android)/) !== null
    // if (navigator.userAgent.match(/(Android)/) === null) {
    //   return false
    // }
  }
  // TODO server device
  return true
}

function getAppVersion() {
  if (typeof window !== 'undefined') {
    const res = /Poizon\/(\d+(\.\d+){0,2})/.exec(navigator.userAgent)
    if (res === null) return '0'
    return res[1]
  }
  return '0'
}
// const appVersion = getAppVersion()

// TODO server device TODO Req params
const isDuApp = () => {
  return typeof window !== 'undefined' ? /poizon/.test(navigator.userAgent.toLowerCase()) : false
}

const canHiddenNavVersion = '2.3.1300'

const isCanHiddenNav = () => {
  const v1 = getAppVersion()
  return isDuApp() && compareVersion(v1, canHiddenNavVersion) > -1
}

const isWeChat = () =>
  typeof window !== 'undefined' ? /micromessenger/.test(navigator.userAgent.toLowerCase()) : false
const isAndroid = () =>
  typeof window !== 'undefined' ? !!navigator.userAgent.match(/(Android)/) : false
const isIOS = () =>
  typeof window !== 'undefined' ? /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) : false

export {
  isDuApp,
  isAndroid,
  isIOS,
  isWeChat,
  isCanHiddenNav,
  // appVersion,
  getIsIphoneX,
  getIsWeChat,
  getIsIphone,
  getIsAndroid,
  getAppVersion,
}
